import { render } from "./TopBar.vue?vue&type=template&id=5919d9bc&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=5919d9bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5919d9bc"

export default script